import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import localeData from 'dayjs/plugin/localeData'
import 'dayjs/locale/en-au'

// Extend Day.js with plugins
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(localeData)

// Set default timezone to Sydney
dayjs.tz.setDefault('Australia/Sydney')

// Set locale to Australian English
dayjs.locale('en-au')

export default {
  install(app) {
    // Create a Sydney timezone helper
    const sydneyDayjs = (date) => {
      return date ? dayjs.tz(date, 'Australia/Sydney') : dayjs.tz()
    }
    
    // Make Day.js available globally as $dayjs
    app.config.globalProperties.$dayjs = sydneyDayjs
    
    // Helper methods for common operations
    app.config.globalProperties.$formatDate = (date) => {
      return sydneyDayjs(date).format('D MMM YYYY')
    }
    
    app.config.globalProperties.$formatDateTime = (date) => {
      return sydneyDayjs(date).format('D MMM YYYY h:mm A')
    }
    
    app.config.globalProperties.$formatTime = (date) => {
      return sydneyDayjs(date).format('h:mm A')
    }
    
    app.config.globalProperties.$toApiDate = (date) => {
      return sydneyDayjs(date).format('YYYY-MM-DD')
    }
    
    app.config.globalProperties.$isToday = (date) => {
      return sydneyDayjs(date).isSame(sydneyDayjs(), 'day')
    }
    
    app.config.globalProperties.$isPast = (date) => {
      return sydneyDayjs(date).isBefore(sydneyDayjs(), 'day')
    }
    
    app.config.globalProperties.$isFuture = (date) => {
      return sydneyDayjs(date).isAfter(sydneyDayjs(), 'day')
    }
    
    // Provide for Composition API
    app.provide('dayjs', sydneyDayjs)
  }
}